export default __webpack_public_path__ + "static/YoutubeUnbiased-eabed0e4d845cdf58047796b0d660f2c.jpg";